import React, { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getScenarioNames } from 'gqlQueries/priceSimulator';
const errorMessage: string = 'Something went wrong!';

function useFetchScenarioNames() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<Array<string> | null>([]);

    const [fetchScenarioNames] = useLazyQuery(getScenarioNames, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getScenarioNames } = payload;
            // const tempNames = ['one', 'two', '33333', 'Scenario Name'];
            setData(getScenarioNames);
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchScenarioNames: () => {
            setLoading(true);
            setError(null);
            fetchScenarioNames();
        },
    };
}

export { useFetchScenarioNames };
